import React from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Loader from 'features/Loader/Loader';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import { getWorkoutLogs } from 'features/clientProfile/components/progressTab/program-overview/ducks/OverviewActions';
import WorkoutHistoryAccordion from './WorkoutHistoryAccordion';
import './WorkoutHistory.scss';

class WorkoutHistory extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getWorkoutLogs(this.clientId);
  }

  render() {
    let { client, workoutLogs, loading, loadingClient } = this.props;

    if (loading || loadingClient) {
      return <Loader />;
    }
    return (
      <div className="workout-history">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}`}>
              {client && `${client.first_name} ${client.last_name}`}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Workout History</Breadcrumb.Item>
          </Breadcrumb>
          <div className="page-title">
            <h4>Workout History</h4>
          </div>

          {workoutLogs && (
            <WorkoutHistoryAccordion
              workoutLogs={workoutLogs}
              clientId={this.clientId}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    workoutLogs: state.overviewReducer.workoutLogs,
    loading: state.overviewReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getWorkoutLogs: clientId => dispatch(getWorkoutLogs(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutHistory);
